import { useContext } from "react";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { IFailureDetailsSelectionProp } from "./FailureDetailsSelectionInterfaces";
import CircleIcon from "@mui/icons-material/Circle";
import { useStyles } from "./FailureDetailsSelection.styles";
import { HMIContext } from "../../contexts/HMIContext/HMIContext";
import { truncateLongText } from "../../utilities/utilities";

export const FailureDetailsSelection = ({
    title,
    name,
    failureDetailStep,
    color,
    truncateText,
}: IFailureDetailsSelectionProp) => {
    const classes = useStyles();
    const { handleSetFailureDetailStep } = useContext(HMIContext);

    const handleButtonClick = (failureDetailStep: number) => (event: React.MouseEvent<unknown>) => {
        handleSetFailureDetailStep(failureDetailStep);
    };

    return (
        <Box className={classes.failureDetailsSelectionContainer}>
            <Typography variant="subtitle2" className={classes.title}>
                {title.toUpperCase()}
            </Typography>
            <Button className={classes.selectionContainer} type="button" onClick={handleButtonClick(failureDetailStep)}>
                <Box className={classes.buttonBox}>
                    {color && <CircleIcon sx={{ color: color }} />}
                    <Typography className={classes.buttonText} variant="subtitle1">
                        {truncateText ? truncateLongText(name, 12) : name}
                    </Typography>
                </Box>
            </Button>
        </Box>
    );
};
